<template>
  <v-col cols="12">
    <v-row>
      <v-col cols="12" class="pa-0 pb-2">
        <v-combobox
          :value="copyOfForm.articles"
          :items="searchedArticles"
          :search-input.sync="searchArticle"
          :label="mess['dialog_request_field_articles']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          item-text="pdm_elementid"
          item-value="id"
          multiple
          color="primary"
          outlined
          dense
          chips
          deletable-chips
          data-vv-name="articles"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedArticles',
              'by_element_id',
              $event
            )
          "
          @change="onChangeArticle('searchArticle', 'articles', $event)"
        />
      </v-col>
    </v-row>

    <v-row key="row-title">
      <v-col cols="12" class="pa-0 pb-2">
        <v-text-field
          v-model="copyOfForm.title"
          v-validate="required.title"
          :label="mess['dialog_request_field_title']"
          :error-messages="errors.collect('title')"
          outlined
          dense
          data-vv-name="title"
        />
      </v-col>
    </v-row>

    <v-row key="row-description">
      <v-col cols="12" class="pa-0 pb-2">
        <v-textarea
          v-model="copyOfForm.description"
          v-validate="required.description"
          :label="mess['dialog_request_field_description']"
          :placeholder="descriptionPlaceholder"
          :error-messages="errors.collect('description')"
          outlined
          dense
          data-vv-name="description"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import getArticles from "@/mixins/GetArticles";
import RequestForm from "@/mixins/RequestForm";

/**
 * @memberOf RequestDialog
 * @name BaseForm
 * @desc Компонент для отрисовки базовой формы.
 *
 * @vue-prop { Object } themes - Массив объектов, где каждый объект представляет отдельную тему обращения.
 *
 * @vue-data { Object } copyOfForm - В этот объект записываются данные из полей, при отправке формы этот
 * объект будет пеедан наверх в корневой компонент.
 * @vue-data { Boolean } [isLoading=false] - Меняется на true при отправке запросы чтобы показать в кнопке отправить прелоадер и запретить возможность повторной
 * отправки формы до того как не уйдет предыдущий запрос.
 * @vue-data { String } [searchArticle=null] - Переменная хранит в себе данные введенные в поле поиск артикула.
 * @vue-data { Array } [searchedArticles=[]] - В эту переменную записываются результаты поиска артикула. Вся логика отправки запроса на поиск артикула вынесена в mixin
 * getArticles.
 */
export default {
  name: "BaseForm",
  inject: ["$validator"],
  mixins: [getArticles, RequestForm],
  props: {
    themes: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      copyOfForm: {},
      isLoading: false,
      searchArticle: null,
      searchedArticles: []
    };
  },
  computed: {
    descriptionPlaceholder() {
      return this.themes?.request_textarea_placeholder || "";
    },
    errors() {
      return {};
    }
  }
};
</script>
